import React, { useState, useEffect } from "react";
import { Box, TextField, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import ModalWrapper from "../ModalWrapper/ModalWrapper";

const CategoryFormModal = ({
	open,
	title,
	initialValue = "",
	onClose,
	onSubmit,
	confirmLabel,
}) => {
	const { t } = useTranslation();
	const [value, setValue] = useState(initialValue);
	const [error, setError] = useState("");
	const [submitting, setSubmitting] = useState(false);

	useEffect(() => {
		if (open) {
			setValue(initialValue || "");
			setError("");
			setSubmitting(false);
		}
	}, [initialValue, open]);

	const handleSubmit = async () => {
		const trimmed = value.trim();
		if (!trimmed) {
			setError(t("UI_TEXT.CATEGORY_REQUIRED") || "Category name is required");
				return;
		}
		setSubmitting(true);
		try {
			await onSubmit?.(trimmed);
			setSubmitting(false);
			onClose?.();
		} catch (err) {
			const message =
				err?.message ||
				err?.response?.data?.message ||
				t("ALERT_MESSAGES.ERROR") ||
				"Something went wrong";
			setError(message);
			setSubmitting(false);
		}
	};

	return (
		<ModalWrapper
			open={open}
			setOpen={() => {}}
			onClose={onClose}
			title={title}
			content={
				<Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 1, width: "100%" }}>
					<TextField
						label={t("LABELS.CATEGORY_NAME") || "Category Name"}
						value={value}
						onChange={(e) => {
							setValue(e.target.value);
							setError("");
						}}
						size="small"
						fullWidth
						error={!!error}
						helperText={error}
					/>
				</Box>
			}
			actions={
				<>
					<Button onClick={onClose}>{t("BUTTON.CANCEL")}</Button>
					<Button onClick={handleSubmit} variant="contained" disabled={submitting}>
						{confirmLabel || t("BUTTON.SAVE") || "Save"}
					</Button>
				</>
			}
		/>
	);
};

export const AddCategoryModal = ({ open, onClose, onSubmit }) => {
	const { t } = useTranslation();
	return (
		<CategoryFormModal
			open={open}
			onClose={onClose}
			onSubmit={onSubmit}
			title={t("UI_TEXT.ADD_CATEGORY") || "Add Category"}
			confirmLabel={t("BUTTON.SAVE") || "Save"}
		/>
	);
};

export const EditCategoryModal = ({ open, category, onClose, onSubmit }) => {
	const { t } = useTranslation();
	return (
		<CategoryFormModal
			open={open}
			onClose={onClose}
			onSubmit={onSubmit}
			title={t("UI_TEXT.EDIT_CATEGORY") || "Edit Category"}
			confirmLabel={t("BUTTON.UPDATE") || "Update"}
			initialValue={category?.category_name || ""}
		/>
	);
};

export default CategoryFormModal;
